import {
  DEFAULT_VACATION_COLORS,
  GOOGLE_CALENDAR_VACATION_COLORS_KEY,
  VacationColors,
} from 'dashboard409a/common/constants/calendar';
import { useLocalStorage } from 'services/hooks/useLocalStorage';

export const getVacationColors = (): VacationColors => {
  try {
    const saved = globalThis.localStorage?.getItem(GOOGLE_CALENDAR_VACATION_COLORS_KEY);
    if (saved) {
      return { ...DEFAULT_VACATION_COLORS, ...(JSON.parse(saved) as Partial<VacationColors>) };
    }
  } catch {
    // ignore
  }
  return DEFAULT_VACATION_COLORS;
};

export const useVacationColors = () => {
  const [colors, setColors] = useLocalStorage<VacationColors>(
    GOOGLE_CALENDAR_VACATION_COLORS_KEY,
    DEFAULT_VACATION_COLORS,
  );

  const handleChange = (key: keyof VacationColors, value: string) =>
    setColors(prev => ({ ...prev, [key]: value }));

  const handleReset = () => setColors(DEFAULT_VACATION_COLORS);

  return { colors, handleChange, handleReset };
};
